"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleSink = void 0;
const types_1 = require("./types");
/**
 * ConsoleSink is responsible for forwarding Log.* statements on to the browser
 * console. It will apply some formatting to each log line.
 *
 * This should only be used in a browser setting, and ideally not on production.
 */
class ConsoleSink extends types_1.LogSink {
    /**
     * Create a new ConsoleSink, taking in the minimumLevel of logs that
     * it should pay attention to.
     *
     * Defaults to { minimumLevel: "debug" }, meaning it will log everything
     */
    constructor({ minimumLevel } = { minimumLevel: "debug" }) {
        super({ minimumLevel });
    }
    next(logEntry) {
        var _a, _b;
        if (this.shouldHandleLogEntry(logEntry) == false) {
            return;
        }
        const { level, message, tags, contexts, originalException, fingerprint, } = logEntry;
        const logPrefix = getLogPrefix(level);
        // obtain stack trace of the call that generated this log
        const error = new Error(typeof message === "string" ? message : message.message);
        const stackFrames = (_a = error.stack) === null || _a === void 0 ? void 0 : _a.match(/at\s.*/gi);
        // a call to Log.* that reaches here goes through 6 different
        // function calls, which therefore creates 6 frames in the stack.
        // we can remove those 6, as they are not useful for the developer,
        // they are just related to the mechanics of our logging
        const cleanStack = stackFrames
            ? stackFrames.slice(6)
            : (_b = error.stack) === null || _b === void 0 ? void 0 : _b.split("\n");
        // conditionally add properties to logData if they contain any data
        const logData = Object.assign({}, tags ? { tags } : {}, contexts ? { contexts } : {}, originalException ? { originalException } : {}, fingerprint ? { fingerprint } : {}, cleanStack ? { stackTrace: cleanStack } : {});
        console[level](`%c${logPrefix.level}%c ${message}`, logPrefix.style, // styles for the prefix
        "font-weight: bold", // styles for the message
        logData);
    }
}
exports.ConsoleSink = ConsoleSink;
const getLogPrefix = (level) => {
    const sharedStyles = "font-weight: bold; padding:2px; border-radius: 2px;";
    switch (level) {
        case "debug":
            return {
                level: "Log.debug",
                style: `background-color:gray; color: white; ${sharedStyles}`,
            };
        case "warn":
            return {
                level: "Log.warn",
                style: `background-color:gold; ${sharedStyles}`,
            };
        case "error":
            return {
                level: "Log.error",
                style: `background-color:red; color: white; ${sharedStyles}`,
            };
        case "info":
        default:
            return {
                level: "Log.info",
                style: `background-color:#037c7cff; color: white; ${sharedStyles}`,
            };
    }
};
//# sourceMappingURL=ConsoleSink.js.map